import React, { useEffect, useState } from "react";
import {
  Send,
  CheckCircle,
  XCircle,
  Clock,
  DollarSign,
  FileText,
  CreditCard,
  Shield,
  IndianRupee,
  Phone,
  MapPin,
  User,
  Calendar,
  TrendingDown,
  MessageSquare,
  AlertTriangle,
  Link2,
  Key,
  PlayCircle,
} from "lucide-react";
import {
  BASE_URL,
  ESTIMATION_SEND_TO_CUSTOMER,
  GET_CUSTOMER_DATA,
  SEND_LOGIN_LINK_SENT_TO_CUSTOMER,
  SEND_PAYMENT_LINK,
} from "../../constants";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import {
  Avatar,
  Box,
  Breadcrumbs,
  Card,
  CircularProgress,
  Typography,
} from "@mui/material";

// Function to generate string avatar (First letters of first and last name)
function stringAvatar(name) {
  return {
    sx: {
      bgcolor: stringToColor(name), // Set background color based on name
    },
    children: `${name.split(" ")[0][0]}${
      name.split(" ")[1] ? name.split(" ")[1][0] : ""
    }`, // First letters of first and last name
  };
}

// Function to convert name to color
function stringToColor(string) {
  let hash = 0;
  let i;

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";
  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  return color;
}

// const CustomerInteraction = () => {
//   const location = useLocation();
//   const { value } = location.state || {};
//   console.log(value);

//   const [customerData, setCustomerData] = useState(null);
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     if (value) {
//       getCustomerDetails(value.id);
//     }
//   }, [value]);

//   const getCustomerDetails = (id) => {
//     setLoading(true);
//     axios
//       .get(`${GET_CUSTOMER_DATA}/status/${id}`)
//       .then((response) => {
//         const { data } = response.data; // Adjust based on API response structure
//         console.log(data);

//         setCustomerData(data);
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.log(error.response?.data?.message || "Error fetching data.");
//         setLoading(false);
//       });
//   };

//   const formatDate = (dateString) => {
//     return new Date(dateString).toLocaleDateString("en-IN", {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//     });
//   };

//   const formatDateTime = (dateString) => {
//     return new Date(dateString).toLocaleString("en-IN", {
//       day: "2-digit",
//       month: "short",
//       hour: "2-digit",
//       minute: "2-digit",
//     });
//   };

//   const formatAmount = (amount) => {
//     return new Intl.NumberFormat("en-IN", {
//       style: "currency",
//       currency: "INR",
//       maximumFractionDigits: 2,
//     }).format(amount);
//   };

//   const getStatusColor = (status) => {
//     switch (status?.toLowerCase()) {
//       case "estimation sent":
//         return "bg-blue-100 text-blue-800";
//       case "payment completed":
//         return "bg-green-100 text-green-800";
//       case "payment link sent":
//         return "bg-yellow-100 text-yellow-800";
//       case "awaiting customer response":
//         return "bg-orange-100 text-orange-800";
//       case "pending":
//         return "bg-red-100 text-red-800";
//       default:
//         return "bg-gray-100 text-gray-800";
//     }
//   };

//   const handleClick = () => {};

//   const handleSendAction = (id) => {
//     const payload = {
//       estimation_id: id,
//       employeeId: localStorage.getItem("username"),
//     };
//     axios
//       .post(`${ESTIMATION_SEND_TO_CUSTOMER}`, payload)
//       .then((response) => {
//         const { data } = response.data; // Adjust based on API response structure
//         console.log(data);
//         // Refresh customer data after successful action
//         getCustomerDetails(customerData?.lead_id);
//       })
//       .catch((error) => {
//         console.log(error.response?.data?.message || "Error fetching data.");
//       });
//   };

//   const handleSendPaymentLink = (id, amount) => {
//     const cleanAmount = Number(amount.replace(/,/g, ""));
//     if (isNaN(cleanAmount)) {
//       console.error("Invalid amount:", amount);
//       return;
//     }
//     const payload = {
//       lead_id: id,
//       payment_amount: cleanAmount,
//       employeeId: localStorage.getItem("username"),
//     };
//     axios
//       .post(`${SEND_PAYMENT_LINK}`, payload)
//       .then((response) => {
//         const { data } = response.data; // Adjust based on API response structure
//         console.log(data);
//         // Refresh customer data after successful action
//         getCustomerDetails(customerData?.lead_id);
//       })
//       .catch((error) => {
//         console.log(error.response?.data?.message || "Error fetching data.");
//       });
//   };

//   const handleSendLoginCredentials = (id) => {
//     const payload = {
//       lead_id: id,
//       bdm_id: localStorage.getItem("username"),
//     };
//     axios
//       .post(`${SEND_LOGIN_LINK_SENT_TO_CUSTOMER}`, payload)
//       .then((response) => {
//         const { data } = response.data; // Adjust based on API response structure
//         console.log(data);
//         // Refresh customer data after successful action
//         getCustomerDetails(customerData?.lead_id);
//       })
//       .catch((error) => {
//         console.log(error.response?.data?.message || "Error fetching data.");
//       });
//   }

//   // Conditional Rendering
//   if (loading) {
//     return (
//       <div className="flex justify-center items-center h-screen bg-gray-50">
//         <div className="bg-white p-8 rounded-xl shadow-lg text-center max-w-md w-full mx-4">
//           <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-teal-600 mx-auto mb-4"></div>
//           <h3 className="text-lg font-bold text-gray-800 mb-2">
//             Fetching data...
//           </h3>
//           <p className="text-gray-600">
//             Please wait while we prepare the report for you.
//           </p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <>
//       <Breadcrumbs separator="›" aria-label="breadcrumb">
//         <Link
//           underline="hover"
//           key="1"
//           color="inherit"
//           to="/bdmAssigned"
//           onClick={handleClick}
//         >
//           Lead
//         </Link>
//         <Typography key="2" color="primary">
//           Interaction
//         </Typography>
//       </Breadcrumbs>

//       <div className="max-w-6xl mx-auto p-6 bg-gray-50 min-h-screen">
//         {/* Current Status Overview */}
//         <div className="bg-white rounded-xl shadow-lg p-6 mb-8">
//           <div className="flex items-center mb-4">
//             <TrendingDown className="w-6 h-6 text-blue-600 mr-3" />
//             <h2 className="text-xl font-semibold text-gray-900">
//               Current Status
//             </h2>
//           </div>
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
//             <div className="p-4 bg-blue-50 rounded-lg">
//               <h3 className="font-semibold text-blue-800">Lead Status</h3>
//               <p
//                 className={`inline-block px-3 py-1 rounded-full text-sm font-medium mt-2 ${getStatusColor(
//                   customerData?.current_status
//                 )}`}
//               >
//                 {customerData?.current_status || "Unknown"}
//               </p>
//             </div>
//             <div className="p-4 bg-green-50 rounded-lg">
//               <h3 className="font-semibold text-green-800">Next Action</h3>
//               <p className="text-gray-700 mt-1">
//                 {customerData?.next_action || "No action required"}
//               </p>
//             </div>
//             {/* <div className="p-4 bg-purple-50 rounded-lg">
//               <h3 className="font-semibold text-purple-800">Total Actions</h3>
//               <p className="text-2xl font-bold text-purple-600 mt-1">
//                 {customerData?.summary?.total_actions || 0}
//               </p>
//             </div> */}
//           </div>
//         </div>

//         {/* Progress Summary */}
//         {/* <div className="bg-white rounded-xl shadow-lg p-6 mb-8">
//           <div className="flex items-center mb-4">
//             <CheckCircle className="w-6 h-6 text-green-600 mr-3" />
//             <h2 className="text-xl font-semibold text-gray-900">
//               Progress Summary
//             </h2>
//           </div>
//           <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
//             <div className="text-center">
//               <div
//                 className={`w-12 h-12 mx-auto rounded-full flex items-center justify-center mb-2 ${
//                   customerData?.progress?.estimation_sent
//                     ? "bg-green-100"
//                     : "bg-gray-100"
//                 }`}
//               >
//                 {customerData?.progress?.estimation_sent ? (
//                   <CheckCircle className="w-6 h-6 text-green-600" />
//                 ) : (
//                   <FileText className="w-6 h-6 text-gray-400" />
//                 )}
//               </div>
//               <p className="text-sm font-medium">Estimation Sent</p>
//             </div>
//             <div className="text-center">
//               <div
//                 className={`w-12 h-12 mx-auto rounded-full flex items-center justify-center mb-2 ${
//                   customerData?.progress?.customer_responded
//                     ? "bg-green-100"
//                     : "bg-gray-100"
//                 }`}
//               >
//                 {customerData?.progress?.customer_responded ? (
//                   <CheckCircle className="w-6 h-6 text-green-600" />
//                 ) : (
//                   <MessageSquare className="w-6 h-6 text-gray-400" />
//                 )}
//               </div>
//               <p className="text-sm font-medium">Customer Response</p>
//             </div>
//             <div className="text-center">
//               <div
//                 className={`w-12 h-12 mx-auto rounded-full flex items-center justify-center mb-2 ${
//                   customerData?.progress?.payment_link_sent
//                     ? "bg-green-100"
//                     : "bg-gray-100"
//                 }`}
//               >
//                 {customerData?.progress?.payment_link_sent ? (
//                   <CheckCircle className="w-6 h-6 text-green-600" />
//                 ) : (
//                   <Link2 className="w-6 h-6 text-gray-400" />
//                 )}
//               </div>
//               <p className="text-sm font-medium">Payment Link</p>
//             </div>
//             <div className="text-center">
//               <div
//                 className={`w-12 h-12 mx-auto rounded-full flex items-center justify-center mb-2 ${
//                   customerData?.progress?.payment_completed
//                     ? "bg-green-100"
//                     : "bg-gray-100"
//                 }`}
//               >
//                 {customerData?.progress?.payment_completed ? (
//                   <CheckCircle className="w-6 h-6 text-green-600" />
//                 ) : (
//                   <IndianRupee className="w-6 h-6 text-gray-400" />
//                 )}
//               </div>
//               <p className="text-sm font-medium">Payment Done</p>
//             </div>
//             <div className="text-center">
//               <div
//                 className={`w-12 h-12 mx-auto rounded-full flex items-center justify-center mb-2 ${
//                   customerData?.progress?.login_credentials_sent
//                     ? "bg-green-100"
//                     : "bg-gray-100"
//                 }`}
//               >
//                 {customerData?.progress?.login_credentials_sent ? (
//                   <CheckCircle className="w-6 h-6 text-green-600" />
//                 ) : (
//                   <Key className="w-6 h-6 text-gray-400" />
//                 )}
//               </div>
//               <p className="text-sm font-medium">Login Credentials</p>
//             </div>
//           </div>
//         </div> */}

//         {/* Estimation Card - Show only if can send estimation or estimation has been sent */}
//         {(customerData?.status_flags?.can_send_estimation ||
//           customerData?.progress?.estimation_sent) && (
//           <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow duration-200 mb-8">
//             <div className="flex items-start justify-between mb-4">
//               <div className="flex items-center space-x-3">
//                 <div className="p-2 bg-blue-50 rounded-lg">
//                   <FileText className="w-6 h-6 text-blue-600" />
//                 </div>
//                 <div className="flex-1">
//                   <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-4 py-2 rounded-xl shadow-sm">
//                     <h3 className="font-bold text-sm leading-tight">
//                       Share Estimation
//                     </h3>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="mb-4">
//               <div
//                 className={`inline-flex items-center space-x-2 px-3 py-1 rounded-full text-sm font-medium border ${
//                   customerData?.progress?.estimation_sent
//                     ? "bg-green-100 text-green-800"
//                     : "bg-gray-100 text-gray-800"
//                 }`}
//               >
//                 {customerData?.progress?.estimation_sent ? (
//                   <CheckCircle className="w-4 h-4 mr-1" />
//                 ) : (
//                   <Clock className="w-4 h-4 mr-1" />
//                 )}
//                 <span>
//                   Status:{" "}
//                   {customerData?.progress?.estimation_sent ? "Sent" : "Pending"}
//                 </span>
//               </div>
//             </div>

//             {customerData?.estimation_info && (
//               <div className="mb-4 p-3 bg-blue-50 rounded-lg">
//                 <div className="space-y-2">
//                   <div className="flex items-center justify-between">
//                     <span className="text-sm font-medium text-blue-600">
//                       Estimation Number:
//                     </span>
//                     <span className="text-sm font-bold text-blue-800">
//                       {customerData.estimation_info.estimation_number}
//                     </span>
//                   </div>
//                   <div className="flex items-center justify-between">
//                     <span className="text-sm font-medium text-blue-600">
//                       Sent Date:
//                     </span>
//                     <span className="text-sm font-bold text-blue-800">
//                       {formatDate(customerData.estimation_info.sent_date)}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             )}

//           <div className="mb-4">
//               <div
//                 className={`inline-flex items-center space-x-2 px-3 py-1 rounded-full text-sm font-medium border ${
//                   customerData?.progress?.customer_responded
//                     ? "bg-green-100 text-green-800"
//                     : "bg-gray-100 text-gray-800"
//                 }`}
//               >
//                 {customerData?.progress?.customer_responded ? (
//                   <CheckCircle className="w-4 h-4 mr-1" />
//                 ) : (
//                   <Clock className="w-4 h-4 mr-1" />
//                 )}
//                 <span>
//                   Customer Response:{" "}
//                   {customerData?.progress?.customer_response === null ? "Pending" : customerData?.progress?.customer_response}
//                 </span>
//               </div>
//             </div>

//             {customerData?.status_flags?.can_send_estimation && (
//               <div className="float-right">
//                 <button
//                   onClick={() => handleSendAction(customerData?.lead_id)}
//                   className="inline-flex items-center space-x-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition-colors duration-200"
//                 >
//                   <Send className="w-4 h-4" />
//                   <span>Send Estimation</span>
//                 </button>
//               </div>
//             )}
//           </div>
//         )}

//         {/* Payment Link Card - Show only if can send payment link or payment link has been sent */}
//         {(customerData?.status_flags?.can_send_payment_link ||
//           customerData?.progress?.payment_link_sent) && (
//           <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow duration-200 mb-8">
//             <div className="flex items-start justify-between mb-4">
//               <div className="flex items-center space-x-3">
//                 <div className="p-2 bg-green-50 rounded-lg">
//                   <IndianRupee className="w-6 h-6 text-green-600" />
//                 </div>
//                 <div className="flex-1">
//                   <div className="bg-gradient-to-r from-green-600 to-emerald-600 text-white px-4 py-2 rounded-xl shadow-sm">
//                     <h3 className="font-bold text-sm leading-tight">
//                       Share Payment Link
//                     </h3>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="mb-4">
//               <div
//                 className={`inline-flex items-center space-x-2 px-3 py-1 rounded-full text-sm font-medium border ${
//                   customerData?.progress?.payment_link_sent
//                     ? "bg-green-100 text-green-800"
//                     : "bg-gray-100 text-gray-800"
//                 }`}
//               >
//                 {customerData?.progress?.payment_link_sent ? (
//                   <CheckCircle className="w-4 h-4 mr-1" />
//                 ) : (
//                   <Clock className="w-4 h-4 mr-1" />
//                 )}
//                 <span>
//                   Status:{" "}
//                   {customerData?.progress?.payment_link_sent
//                     ? "Sent"
//                     : "Pending"}
//                 </span>
//               </div>
//             </div>

//             <div className="mb-4 p-3 bg-green-50 rounded-lg">
//               <div className="space-y-2">
//                 <div className="flex items-center justify-between">
//                   <span className="text-sm font-medium text-green-600">
//                     Payment Status:
//                   </span>
//                   <span
//                     className={`text-sm font-bold ${
//                       customerData?.progress?.payment_completed
//                         ? "text-green-600"
//                         : "text-orange-600"
//                     }`}
//                   >
//                     {customerData?.progress?.payment_completed
//                       ? "Completed"
//                       : "Pending"}
//                   </span>
//                 </div>
//                 <div className="flex items-center justify-between">
//                   <span className="text-sm font-medium text-green-600">
//                     Payment Modes:
//                   </span>
//                   <span className={`text-sm font-bold text-green-600`}>
//                     {customerData?.payment_info?.payment_modes?.length ? (
//                       <span>
//                         {customerData.payment_info.payment_modes.join(", ")}
//                       </span>
//                     ) : (
//                       <span>No payment mode selected</span>
//                     )}
//                   </span>
//                 </div>
//                 {customerData?.payment_info && (
//                   <div className="flex items-center justify-between">
//                     <span className="text-sm font-medium text-green-600">
//                       Amount Paid:
//                     </span>
//                     <span className="text-lg font-bold text-green-600">
//                       {formatAmount(
//                         customerData.payment_info.total_amount_paid
//                       )}
//                     </span>
//                   </div>
//                 )}
//               </div>
//             </div>

//             {customerData?.status_flags?.can_send_payment_link && (
//               <div className="float-right">
//                 <button
//                   onClick={() =>
//                     handleSendPaymentLink(customerData?.lead_id, "10000")
//                   }
//                   className="inline-flex items-center space-x-2 px-4 py-2 bg-green-600 hover:bg-green-700 text-white text-sm font-medium rounded-lg transition-colors duration-200"
//                 >
//                   <Send className="w-4 h-4" />
//                   <span>Send Payment Link</span>
//                 </button>
//               </div>
//             )}
//           </div>
//         )}

//         {/* Login Credentials Card - Show only if can send login credentials */}
//         {customerData?.status_flags?.can_send_login_credentials && (
//           <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow duration-200 mb-8">
//             <div className="flex items-start justify-between mb-4">
//               <div className="flex items-center space-x-3">
//                 <div className="p-2 bg-purple-50 rounded-lg">
//                   <Key className="w-6 h-6 text-purple-600" />
//                 </div>
//                 <div className="flex-1">
//                   <div className="bg-gradient-to-r from-purple-600 to-violet-600 text-white px-4 py-2 rounded-xl shadow-sm">
//                     <h3 className="font-bold text-sm leading-tight">
//                       Login Credentials
//                     </h3>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="mb-4">
//               <div
//                 className={`inline-flex items-center space-x-2 px-3 py-1 rounded-full text-sm font-medium border ${
//                   customerData?.progress?.login_credentials_sent
//                     ? "bg-green-100 text-green-800"
//                     : "bg-gray-100 text-gray-800"
//                 }`}
//               >
//                 {customerData?.progress?.login_credentials_sent ? (
//                   <CheckCircle className="w-4 h-4 mr-1" />
//                 ) : (
//                   <Clock className="w-4 h-4 mr-1" />
//                 )}
//                 <span>
//                   Status:{" "}
//                   {customerData?.progress?.login_credentials_sent
//                     ? "Sent"
//                     : "Ready to Send"}
//                 </span>
//               </div>
//             </div>

//             <div className="float-right">
//               <button
//                 onClick={() => handleSendLoginCredentials(customerData?.lead_id)}
//                 className="inline-flex items-center space-x-2 px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white text-sm font-medium rounded-lg transition-colors duration-200"
//               >
//                 <Send className="w-4 h-4" />
//                 <span>Send Login Credentials</span>
//               </button>
//             </div>
//           </div>
//         )}

//         {/* Action History */}
//         <div className="bg-white rounded-xl shadow-lg p-6">
//           <div className="flex items-center mb-6">
//             <Clock className="w-6 h-6 text-purple-600 mr-3" />
//             <h2 className="text-xl font-semibold text-gray-900">
//               Action History
//             </h2>
//           </div>
//           <div className="space-y-4">
//             {customerData?.action_history?.map((action, index) => (
//               <div
//                 key={index}
//                 className="flex items-start space-x-4 p-4 bg-gray-50 rounded-lg"
//               >
//                 <div className="flex-shrink-0">
//                   <div
//                     className={`w-8 h-8 rounded-full flex items-center justify-center ${
//                       action.performed_by === "Customer"
//                         ? "bg-green-600"
//                         : "bg-blue-600"
//                     }`}
//                   >
//                     <span className="text-white text-xs font-medium">
//                       {action.performed_by === "Customer" ? "C" : "E"}
//                     </span>
//                   </div>
//                 </div>
//                 <div className="flex-grow">
//                   <div className="flex items-center space-x-2 mb-1">
//                     <span className="font-medium text-gray-900">
//                       {action.action}
//                     </span>
//                     <span
//                       className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(
//                         action.action
//                       )}`}
//                     >
//                       {action.performed_by}
//                     </span>
//                   </div>
//                   <p className="text-sm text-gray-500">
//                     {formatDateTime(action.date)}
//                   </p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default CustomerInteraction;

const CustomerInteraction = () => {
  const location = useLocation();
  const { value } = location.state || {};
  console.log(value);

  const [customerData, setCustomerData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (value) {
      getCustomerDetails(value.id);
    }
  }, [value]);

  const getCustomerDetails = (id) => {
    setLoading(true);
    axios
      .get(`${GET_CUSTOMER_DATA}/status/${id}`)
      .then((response) => {
        const { data } = response.data; // Adjust based on API response structure
        console.log(data);

        setCustomerData(data);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error.response?.data?.message || "Error fetching data.");
        setLoading(false);
      });
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const formatDateTime = (dateString) => {
    return new Date(dateString).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const formatAmount = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 2,
    }).format(amount);
  };

  const handleSendAction = (id) => {
    console.log("Send estimation for:", id);
    const payload = {
            estimation_id: id,
            employeeId: localStorage.getItem("username"),
          };
          axios
            .post(`${ESTIMATION_SEND_TO_CUSTOMER}`, payload)
            .then((response) => {
              const { data } = response.data; // Adjust based on API response structure
              console.log(data);
              // Refresh customer data after successful action
              getCustomerDetails(customerData?.lead_id);
            })
            .catch((error) => {
              console.log(error.response?.data?.message || "Error fetching data.");
            });
  };

  const handleSendPaymentLink = (id, amount) => {
    console.log("Send payment link for:", id, "Amount:", amount);
    const cleanAmount = Number(amount.replace(/,/g, ""));
    if (isNaN(cleanAmount)) {
      console.error("Invalid amount:", amount);
      return;
    }
    const payload = {
      lead_id: id,
      payment_amount: cleanAmount,
      employeeId: localStorage.getItem("username"),
    };
    axios
      .post(`${SEND_PAYMENT_LINK}`, payload)
      .then((response) => {
        const { data } = response.data; // Adjust based on API response structure
        console.log(data);
        // Refresh customer data after successful action
        getCustomerDetails(customerData?.lead_id);
      })
      .catch((error) => {
        console.log(error.response?.data?.message || "Error fetching data.");
      });
  };

  const handleSendLoginCredentials = (id) => {
    console.log("Send login credentials for:", id);
    const payload = {
            lead_id: id,
            bdm_id: localStorage.getItem("username"),
          };
          axios
            .post(`${SEND_LOGIN_LINK_SENT_TO_CUSTOMER}`, payload)
            .then((response) => {
              const { data } = response.data; // Adjust based on API response structure
              console.log(data);
              // Refresh customer data after successful action
              getCustomerDetails(customerData?.lead_id);
            })
            .catch((error) => {
              console.log(error.response?.data?.message || "Error fetching data.");
            });
  };

  // Timeline steps configuration
  const timelineSteps = [
    {
      id: "estimation",
      title: "Share Estimation",
      icon: FileText,
      color: "blue",
      completed: customerData?.progress?.estimation_sent,
      canPerform: customerData?.status_flags?.can_send_estimation,
      action: () => handleSendAction(18),
      details: customerData?.estimation_info,
      response: customerData?.progress?.customer_response,
      hasResponse: customerData?.progress?.customer_responded,
    },
    {
      id: "payment",
      title: "Payment Link",
      icon: IndianRupee,
      color: "green",
      completed: customerData?.progress?.payment_completed,
      canPerform: customerData?.status_flags?.can_send_payment_link,
      action: () => handleSendPaymentLink(customerData?.lead_id, "1"),
      details: customerData?.payment_info,
      linkSent: customerData?.progress?.payment_link_sent,
    },
    {
      id: "credentials",
      title: "Login Credentials",
      icon: Key,
      color: "purple",
      completed: customerData?.progress?.login_credentials_sent,
      canPerform: customerData?.status_flags?.can_send_login_credentials,
      action: () => handleSendLoginCredentials(customerData?.lead_id),
    },
  ];

  const getColorClasses = (color, variant = "primary") => {
    const colorMap = {
      blue: {
        primary: "bg-blue-600 text-white",
        light: "bg-blue-50 text-blue-700",
        border: "border-blue-600",
        ring: "ring-blue-600",
        gradient: "from-blue-600 to-indigo-600",
      },
      green: {
        primary: "bg-green-600 text-white",
        light: "bg-green-50 text-green-700",
        border: "border-green-600",
        ring: "ring-green-600",
        gradient: "from-green-600 to-emerald-600",
      },
      purple: {
        primary: "bg-purple-600 text-white",
        light: "bg-purple-50 text-purple-700",
        border: "border-purple-600",
        ring: "ring-purple-600",
        gradient: "from-purple-600 to-violet-600",
      },
    };
    return colorMap[color]?.[variant] || "";
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen bg-gray-50">
        <div className="bg-white p-8 rounded-xl shadow-lg text-center max-w-md w-full mx-4">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-teal-600 mx-auto mb-4"></div>
          <h3 className="text-lg font-bold text-gray-800 mb-2">
            Fetching data...
          </h3>
          <p className="text-gray-600">
            Please wait while we prepare the report for you.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-5xl mx-auto p-6 bg-gradient-to-br from-gray-50 to-gray-100 min-h-screen">
      {/* Header Section */}
      <div className="mb-8">
        <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
          

          {/* Customer Information Card */}
          {customerData?.customer_info && (
            <div className="mb-6 p-6 bg-gradient-to-r from-indigo-50 to-blue-50 rounded-xl border border-indigo-100">
              

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {/* Customer Details */}
                <div className="space-y-3">
                  <div className="flex items-center space-x-3">
                    <User className="w-5 h-5 text-indigo-600 flex-shrink-0" />
                    <div>
                      <div className="text-sm text-gray-500">Customer Name</div>
                      <div className="font-semibold text-gray-900">
                        {customerData.customer_info.customer_name}
                      </div>
                    </div>
                  </div>

                  <div className="flex items-center space-x-3">
                    <Phone className="w-5 h-5 text-green-600 flex-shrink-0" />
                    <div>
                      <div className="text-sm text-gray-500">Mobile</div>
                      <div className="font-semibold text-gray-900">
                        {customerData.customer_info.customer_mobile}
                      </div>
                    </div>
                  </div>

                  {customerData.customer_info.customer_whatsapp &&
                    customerData.customer_info.customer_whatsapp !==
                      customerData.customer_info.customer_mobile && (
                      <div className="flex items-center space-x-3">
                        <MessageSquare className="w-5 h-5 text-green-500 flex-shrink-0" />
                        <div>
                          <div className="text-sm text-gray-500">WhatsApp</div>
                          <div className="font-semibold text-gray-900">
                            {customerData.customer_info.customer_whatsapp}
                          </div>
                        </div>
                      </div>
                    )}
                </div>

                {/* Address Information */}
                <div className="space-y-3">
                  <div className="flex items-start space-x-3">
                    <MapPin className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
                    <div>
                      <div className="text-sm text-gray-500">Location</div>
                      <div className="font-semibold text-gray-900">
                        {customerData.customer_info.customer_address.location}
                      </div>
                      <div className="text-sm text-gray-600">
                        {customerData.customer_info.customer_address.state_name}
                      </div>
                      <div className="text-sm text-gray-600">
                        PIN:{" "}
                        {customerData.customer_info.customer_address.pincode}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Current Status Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-purple-600 opacity-10 rounded-xl"></div>
              <div className="relative p-6 bg-white rounded-xl border border-gray-200">
                <div className="flex items-center space-x-3 mb-2">
                  <TrendingDown className="w-6 h-6 text-blue-600" />
                  <h3 className="font-semibold text-gray-900">
                    Current Status
                  </h3>
                </div>
                <div className="text-2xl font-bold text-blue-600">
                  {customerData?.current_status || "Unknown"}
                </div>
              </div>
            </div>

            <div className="relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-r from-green-500 to-teal-600 opacity-10 rounded-xl"></div>
              <div className="relative p-6 bg-white rounded-xl border border-gray-200">
                <div className="flex items-center space-x-3 mb-2">
                  <PlayCircle className="w-6 h-6 text-green-600" />
                  <h3 className="font-semibold text-gray-900">Next Action</h3>
                </div>
                <div className="text-xl font-semibold text-green-600">
                  {customerData?.next_action || "No action required"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Timeline Section */}
      <div className="bg-white rounded-2xl shadow-xl p-3 mb-8 border border-gray-100">
        <div className="flex items-center space-x-3 mb-8">
          <div className="p-2 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-lg">
            <Calendar className="w-6 h-6 text-white" />
          </div>
          <h2 className="text-2xl font-bold text-gray-900">Process Timeline</h2>
        </div>

        <div className="relative">
          {/* Timeline Line */}
          <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-gradient-to-b from-gray-300 via-gray-200 to-gray-300"></div>

          <div className="space-y-4">
            {timelineSteps.map((step, index) => {
              const Icon = step.icon;
              const isActive = step.completed || step.canPerform;
              const isCompleted = step.completed;

              return (
                <div
                  key={step.id}
                  className="relative flex items-start space-x-4"
                >
                  {/* Timeline Node */}
                  <div className="relative z-10 flex-shrink-0">
                    <div
                      className={`w-16 h-16 rounded-full flex items-center justify-center shadow-lg transition-all duration-300 ${
                        isCompleted
                          ? `${getColorClasses(
                              step.color,
                              "primary"
                            )} ring-4 ${getColorClasses(
                              step.color,
                              "ring"
                            )} ring-opacity-20`
                          : isActive
                          ? `bg-white ${getColorClasses(
                              step.color,
                              "border"
                            )} border-2 shadow-xl`
                          : "bg-gray-100 text-gray-400 border-2 border-gray-200"
                      }`}
                    >
                      {isCompleted ? (
                        <CheckCircle className="w-8 h-8" />
                      ) : (
                        <Icon className="w-8 h-8" />
                      )}
                    </div>

                    {/* Pulse animation for active step */}
                    {isActive && !isCompleted && (
                      <div
                        className={`absolute inset-0 rounded-full ${getColorClasses(
                          step.color,
                          "primary"
                        )} opacity-20 animate-ping`}
                      ></div>
                    )}
                  </div>

                  {/* Content Card */}
                  <div
                    className={`flex-1 transition-all duration-300 ${
                      isActive ? "transform -translate-y-1" : ""
                    }`}
                  >
                    <div
                      className={`rounded-xl border-2 transition-all duration-300 ${
                        isCompleted
                          ? `bg-gradient-to-r ${getColorClasses(
                              step.color,
                              "gradient"
                            )} text-white shadow-lg`
                          : isActive
                          ? `bg-white ${getColorClasses(
                              step.color,
                              "border"
                            )} shadow-xl`
                          : "bg-gray-50 border-gray-200"
                      }`}
                    >
                      <div className="p-4">
                        {/* Header */}
                        <div className="flex items-center justify-between mb-4">
                          <h3
                            className={`text-xl font-bold ${
                              isCompleted
                                ? "text-white"
                                : isActive
                                ? `text-${step.color}-700`
                                : "text-gray-600"
                            }`}
                          >
                            {step.title}
                          </h3>

                          {/* Status Badge */}
                          <div className="flex items-center space-x-2">
                            {isCompleted && (
                              <span
                                className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium"
                                style={{
                                  backgroundColor: "rgba(255,255,255,0.2)",
                                }}
                              >
                                <CheckCircle className="w-4 h-4 mr-1" />
                                Completed
                              </span>
                            )}
                            {!isCompleted && isActive && (
                              <span
                                className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${getColorClasses(
                                  step.color,
                                  "light"
                                )}`}
                              >
                                <Clock className="w-4 h-4 mr-1" />
                                Ready
                              </span>
                            )}
                            {!isCompleted && !isActive && (
                              <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-gray-100 text-gray-600">
                                <Clock className="w-4 h-4 mr-1" />
                                Waiting
                              </span>
                            )}
                          </div>
                        </div>

                        {/* Details Section */}
                        {step.details && (
                          <div
                            className={`mb-4 p-4 rounded-lg ${
                              isCompleted
                                ? "bg-white bg-opacity-10"
                                : `${getColorClasses(
                                    step.color,
                                    "light"
                                  )} bg-opacity-50`
                            }`}
                          >
                            {step.id === "estimation" && (
                              <div className="space-y-2">
                                <div className="flex justify-between items-center">
                                  <span
                                    className={`text-sm font-medium ${
                                      isCompleted
                                        ? "text-white opacity-90"
                                        : `text-${step.color}-700`
                                    }`}
                                  >
                                    Estimation Number:
                                  </span>
                                  <span
                                    className={`text-sm font-bold ${
                                      isCompleted
                                        ? "text-white"
                                        : `text-${step.color}-800`
                                    }`}
                                  >
                                    {step.details.estimation_number}
                                  </span>
                                </div>
                                <div className="flex justify-between items-center">
                                  <span
                                    className={`text-sm font-medium ${
                                      isCompleted
                                        ? "text-white opacity-90"
                                        : `text-${step.color}-700`
                                    }`}
                                  >
                                    Sent Date:
                                  </span>
                                  <span
                                    className={`text-sm font-bold ${
                                      isCompleted
                                        ? "text-white"
                                        : `text-${step.color}-800`
                                    }`}
                                  >
                                    {formatDate(step.details.sent_date)}
                                  </span>
                                </div>
                                {step.hasResponse && (
                                  <div className="mt-3 pt-3 border-t border-white border-opacity-20">
                                    <div className="flex items-center space-x-2">
                                      <MessageSquare className="w-4 h-4" />
                                      <span className="text-sm font-medium">
                                        Customer Response:
                                      </span>
                                      <span className="text-sm font-bold">
                                        {step.response}
                                      </span>
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}

                            {step.id === "payment" && (
                              <div className="space-y-2">
                                <div className="flex justify-between items-center">
                                  <span
                                    className={`text-sm font-medium ${
                                      isCompleted
                                        ? "text-white opacity-90"
                                        : `text-${step.color}-700`
                                    }`}
                                  >
                                    Payment Status:
                                  </span>
                                  <span
                                    className={`text-sm font-bold ${
                                      step.completed
                                        ? "text-green-600"
                                        : "text-orange-600"
                                    }`}
                                  >
                                    {step.completed
                                      ? "Completed"
                                      : step.linkSent
                                      ? "Link Sent"
                                      : "Pending"}
                                  </span>
                                </div>
                                <div className="flex justify-between items-center">
                                  <span
                                    className={`text-sm font-medium ${
                                      isCompleted
                                        ? "text-white opacity-90"
                                        : `text-${step.color}-700`
                                    }`}
                                  >
                                    Payment Modes:
                                  </span>
                                  <span
                                    className={`text-sm font-bold ${
                                      isCompleted
                                        ? "text-white"
                                        : `text-${step.color}-800`
                                    }`}
                                  >
                                    {step.details.payment_modes?.join(", ") ||
                                      "Not selected"}
                                  </span>
                                </div>
                                <div className="flex justify-between items-center">
                                  <span
                                    className={`text-sm font-medium ${
                                      isCompleted
                                        ? "text-white opacity-90"
                                        : `text-${step.color}-700`
                                    }`}
                                  >
                                    Amount Paid:
                                  </span>
                                  <span
                                    className={`text-lg font-bold ${
                                      isCompleted
                                        ? "text-white"
                                        : `text-${step.color}-800`
                                    }`}
                                  >
                                    {formatAmount(
                                      step.details.total_amount_paid
                                    )}
                                  </span>
                                </div>
                              </div>
                            )}
                          </div>
                        )}

                        {/* Action Button */}
                        {step.canPerform && (
                          <div className="flex justify-end">
                            <button
                              onClick={step.action}
                              className={`inline-flex items-center space-x-2 px-6 py-3 ${getColorClasses(
                                step.color,
                                "primary"
                              )} text-sm font-medium rounded-lg hover:shadow-lg transform hover:scale-105 transition-all duration-200`}
                            >
                              <Send className="w-4 h-4" />
                              <span>
                                {step.id === "estimation" && "Send Estimation"}
                                {step.id === "payment" && "Send Payment Link"}
                                {step.id === "credentials" &&
                                  "Send Login Credentials"}
                              </span>
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Action History */}
      <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
        <div className="flex items-center space-x-3 mb-6">
          <div className="p-2 bg-gradient-to-r from-purple-500 to-pink-600 rounded-lg">
            <Clock className="w-6 h-6 text-white" />
          </div>
          <h2 className="text-2xl font-bold text-gray-900">Action History</h2>
        </div>

        <div className="space-y-4">
          {customerData?.action_history?.map((action, index) => (
            <div
              key={index}
              className="group flex items-start space-x-4 p-4 bg-gradient-to-r from-gray-50 to-gray-100 rounded-xl hover:from-blue-50 hover:to-indigo-50 transition-all duration-200 border border-gray-100 hover:border-blue-200"
            >
              <div className="flex-shrink-0">
                <div
                  className={`w-12 h-12 rounded-full flex items-center justify-center shadow-md transition-all duration-200 group-hover:shadow-lg ${
                    action.performed_by === "Customer"
                      ? "bg-gradient-to-r from-green-500 to-emerald-600 text-white"
                      : "bg-gradient-to-r from-blue-500 to-indigo-600 text-white"
                  }`}
                >
                  <span className="text-sm font-bold">
                    {action.performed_by === "Customer" ? "C" : "E"}
                  </span>
                </div>
              </div>
              <div className="flex-grow">
                <div className="flex items-center justify-between mb-2">
                  <span className="font-semibold text-gray-900 group-hover:text-blue-900 transition-colors">
                    {action.action}
                  </span>
                  <span
                    className={`px-3 py-1 rounded-full text-xs font-medium ${
                      action.performed_by === "Customer"
                        ? "bg-green-100 text-green-700"
                        : "bg-blue-100 text-blue-700"
                    }`}
                  >
                    {action.performed_by}
                  </span>
                </div>
                <div className="flex items-center space-x-2 text-sm text-gray-500">
                  <Calendar className="w-4 h-4" />
                  <span>{formatDateTime(action.date)}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CustomerInteraction;
